<template>
  <div>
    <Table style="margin-top: 1rem;" class="panorama-summary-table">
      <TableHeader>
        <TableRow>
          <TableHead
            v-for="(panoramaSummaryCol, index) of panoramaSummaryColumns"
            :key="`${panoramaSummaryCol.label}_${index}`"
            :colspan="panoramaSummaryCol.colspan"
            :class="panoramaSummaryCol.class"
          >
            <span :style="panoramaSummaryCol.style"
              >{{ panoramaSummaryCol.label }}
              <b-button
                v-if="panoramaSummaryCol.label === 'Status Fatura'"
                @click="() => toggleAllGroupsAndSubgroups()"
                size="sm"
                variant="outline-secondary"
              >
                <span v-if="toggleGroups.length === 0">Desagrupar</span>
                <span v-else>Agrupar</span>
              </b-button>
            </span>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody
        v-for="(panoramaGroup, panoramaGroupIndex) of panoramaStatusSummaryList"
        :key="`${panoramaGroup.name}_${panoramaGroupIndex}`"
      >
        <TableRow class="group-row">
          <TableCell
            class="panorama-summary-table-cell pinned lv0 divider"
            :style="setInvoiceSummaryStatusColor(panoramaGroup.name)"
            colspan="3"
          >
            <div
              style="display: flex; justify-content: space-between; align-items: center;"
              class="status"
            >
              {{ translatePanoramaSummaryStatusName(panoramaGroup.name) }}
              <b-icon-chevron-down
                v-if="
                  (panoramaGroup.subGroups.length > 0 ||
                    panoramaGroup.status.length > 0) &&
                    !toggleGroups.includes(panoramaGroup.name)
                "
                @click="toggleGroup(panoramaGroup.name)"
              ></b-icon-chevron-down>
              <b-icon-chevron-up
                v-else-if="
                  panoramaGroup.subGroups.length > 0 ||
                    panoramaGroup.status.length > 0
                "
                @click="toggleGroup(panoramaGroup.name)"
              ></b-icon-chevron-up>
            </div>
          </TableCell>
          <TableCell
            class="panorama-summary-table-cell divider pinned lv3"
            style="text-align: right;"
          >
            <RenderPanoramaSummaryInvoiceLine
              :invoice-value="panoramaGroup.total"
              :qty-invoices="panoramaGroup.qtyInvoices"
              :overall-percentage-invoice-value="
                panoramaGroup.percentageOfTotalOverall
              "
              :status="panoramaGroup.name"
              :show-invoice-value="selectedFields.invoiceValue"
              :show-qty-invoice="selectedFields.qtyInvoices"
              :show-overall-percentage="selectedFields.overallPercentage"
              :show-sub-total-percentage="selectedFields.subTotalPercentage"
              :show-average-ticket="selectedFields.averageTicket"
            />
          </TableCell>
          <template
            v-for="([key, invoiceData], index) in Array.from(
              panoramaGroup.invoicesData,
            )"
          >
            <TableCell
              class="panorama-summary-table-cell divider"
              style="text-align: right;"
            >
              <RenderPanoramaSummaryInvoiceLine
                :invoice-value="invoiceData.total || 0"
                :qty-invoices="invoiceData.qtyInvoices || 0"
                :overall-percentage-invoice-value="
                  invoiceData.percentageOfTotalOverall || 0
                "
                :sub-total-percentage-invoice-value="
                  invoiceData.percentageOfSubTotal || 0
                "
                :status="panoramaGroup.name"
                :show-invoice-value="selectedFields.invoiceValue"
                :show-qty-invoice="selectedFields.qtyInvoices"
                :show-overall-percentage="selectedFields.overallPercentage"
                :show-sub-total-percentage="selectedFields.subTotalPercentage"
                :show-average-ticket="selectedFields.averageTicket"
              />
            </TableCell>
          </template>
        </TableRow>
        <TableRow
          v-for="(panoramaStatus, index) of panoramaGroup.status"
          v-if="toggleGroups.includes(panoramaGroup.name)"
          :key="`${panoramaStatus.name}_${index}`"
          class="status-row"
        >
          <TableCell class="pinned lv0">
            <div class="empty-cell"></div>
          </TableCell>

          <TableCell
            class="panorama-summary-table-cell pinned lv1 divider"
            :style="setInvoiceSummaryStatusColor(panoramaStatus.name)"
            colspan="2"
          >
            <div class="status">
              {{ translatePanoramaSummaryStatusName(panoramaStatus.name) }}
            </div>
          </TableCell>
          <TableCell
            class="panorama-summary-table-cell divider pinned lv3"
            style="text-align: right;"
          >
            <RenderPanoramaSummaryInvoiceLine
              :invoice-value="panoramaStatus.total"
              :qty-invoices="panoramaStatus.qtyInvoices"
              :overall-percentage-invoice-value="
                panoramaStatus.percentageOfTotalOverall
              "
              :status="panoramaStatus.name"
              :show-invoice-value="selectedFields.invoiceValue"
              :show-qty-invoice="selectedFields.qtyInvoices"
              :show-overall-percentage="selectedFields.overallPercentage"
              :show-sub-total-percentage="selectedFields.subTotalPercentage"
              :show-average-ticket="selectedFields.averageTicket"
            />
          </TableCell>
          <template
            v-for="([key, invoiceData], index) in Array.from(
              panoramaStatus.invoicesData,
            )"
          >
            <TableCell
              class="panorama-summary-table-cell divider"
              style="text-align: right;"
            >
              <RenderPanoramaSummaryInvoiceLine
                :invoice-value="invoiceData.total || 0"
                :qty-invoices="invoiceData.qtyInvoices || 0"
                :overall-percentage-invoice-value="
                  invoiceData.percentageOfTotalOverall || 0
                "
                :sub-total-percentage-invoice-value="
                  invoiceData.percentageOfSubTotal || 0
                "
                :status="panoramaStatus.name"
                :show-invoice-value="selectedFields.invoiceValue"
                :show-qty-invoice="selectedFields.qtyInvoices"
                :show-overall-percentage="selectedFields.overallPercentage"
                :show-sub-total-percentage="selectedFields.subTotalPercentage"
                :show-average-ticket="selectedFields.averageTicket"
              />
            </TableCell>
          </template>
        </TableRow>
        <template
          v-for="(panoramaSubGroup,
          panoramaSubgroupIndex) of panoramaGroup.subGroups"
          v-if="toggleGroups.includes(panoramaGroup.name)"
        >
          <TableRow class="subgroup-row">
            <TableCell class="pinned lv0">
              <div class="empty-cell"></div>
            </TableCell>
            <TableCell
              class="panorama-summary-table-cell pinned lv1 divider"
              :style="setInvoiceSummaryStatusColor(panoramaSubGroup.name)"
              colspan="2"
            >
              <div
                style="display: flex; justify-content: space-between; align-items: center;"
                class="status"
              >
                {{ translatePanoramaSummaryStatusName(panoramaSubGroup.name) }}
                <b-icon-chevron-down
                  v-if="!toggleSubgroups.includes(panoramaSubGroup.name)"
                  @click="toggleSubgroup(panoramaSubGroup.name)"
                ></b-icon-chevron-down>
                <b-icon-chevron-up
                  v-else
                  @click="toggleSubgroup(panoramaSubGroup.name)"
                ></b-icon-chevron-up>
              </div>
            </TableCell>
            <TableCell
              class="panorama-summary-table-cell divider pinned lv3"
              style="text-align: right;"
            >
              <RenderPanoramaSummaryInvoiceLine
                :invoice-value="panoramaSubGroup.total"
                :qty-invoices="panoramaSubGroup.qtyInvoices"
                :overall-percentage-invoice-value="
                  panoramaSubGroup.percentageOfTotalOverall
                "
                :status="panoramaSubGroup.name"
                :show-invoice-value="selectedFields.invoiceValue"
                :show-qty-invoice="selectedFields.qtyInvoices"
                :show-overall-percentage="selectedFields.overallPercentage"
                :show-sub-total-percentage="selectedFields.subTotalPercentage"
                :show-average-ticket="selectedFields.averageTicket"
              />
            </TableCell>
            <template
              v-for="([key, invoiceData], index) in Array.from(
                panoramaSubGroup.invoicesData,
              )"
            >
              <TableCell
                class="panorama-summary-table-cell divider"
                style="text-align: right;"
              >
                <!-- Agora você acessa normalmente as propriedades em invoiceData -->
                <RenderPanoramaSummaryInvoiceLine
                  :invoice-value="invoiceData.total || 0"
                  :qty-invoices="invoiceData.qtyInvoices || 0"
                  :overall-percentage-invoice-value="
                    invoiceData.percentageOfTotalOverall || 0
                  "
                  :sub-total-percentage-invoice-value="
                    invoiceData.percentageOfSubTotal || 0
                  "
                  :status="panoramaSubGroup.name"
                  :show-invoice-value="selectedFields.invoiceValue"
                  :show-qty-invoice="selectedFields.qtyInvoices"
                  :show-overall-percentage="selectedFields.overallPercentage"
                  :show-sub-total-percentage="selectedFields.subTotalPercentage"
                  :show-average-ticket="selectedFields.averageTicket"
                />
              </TableCell>
            </template>
          </TableRow>
          <TableRow
            v-for="(panoramaStatus, index) of panoramaSubGroup.status"
            v-if="
              toggleGroups.includes(panoramaGroup.name) &&
                toggleSubgroups.includes(panoramaSubGroup.name)
            "
            :key="`${panoramaStatus.name}_${index}`"
            class="status-row"
          >
            <TableCell class="pinned lv0">
              <div class="empty-cell"></div>
            </TableCell>
            <TableCell class="pinned lv1">
              <div class="empty-cell"></div>
            </TableCell>

            <TableCell
              class="panorama-summary-table-cell pinned lv2 divider"
              :style="setInvoiceSummaryStatusColor(panoramaStatus.name)"
            >
              <div class="status">
                {{ translatePanoramaSummaryStatusName(panoramaStatus.name) }}
              </div>
            </TableCell>
            <TableCell
              class="panorama-summary-table-cell divider pinned lv3"
              style="text-align: right;"
            >
              <RenderPanoramaSummaryInvoiceLine
                :invoice-value="panoramaStatus.total"
                :qty-invoices="panoramaStatus.qtyInvoices"
                :overall-percentage-invoice-value="
                  panoramaStatus.percentageOfTotalOverall
                "
                :status="panoramaStatus.name"
                :show-invoice-value="selectedFields.invoiceValue"
                :show-qty-invoice="selectedFields.qtyInvoices"
                :show-overall-percentage="selectedFields.overallPercentage"
                :show-sub-total-percentage="selectedFields.subTotalPercentage"
                :show-average-ticket="selectedFields.averageTicket"
              />
            </TableCell>
            <template
              v-for="([key, invoiceData], index) in Array.from(
                panoramaStatus.invoicesData,
              )"
            >
              <TableCell
                class="panorama-summary-table-cell divider"
                style="text-align: right;"
              >
                <RenderPanoramaSummaryInvoiceLine
                  :invoice-value="invoiceData.total || 0"
                  :qty-invoices="invoiceData.qtyInvoices || 0"
                  :overall-percentage-invoice-value="
                    invoiceData.percentageOfTotalOverall || 0
                  "
                  :sub-total-percentage-invoice-value="
                    invoiceData.percentageOfSubTotal || 0
                  "
                  :status="panoramaStatus.name"
                  :show-invoice-value="selectedFields.invoiceValue"
                  :show-qty-invoice="selectedFields.qtyInvoices"
                  :show-overall-percentage="selectedFields.overallPercentage"
                  :show-sub-total-percentage="selectedFields.subTotalPercentage"
                  :show-average-ticket="selectedFields.averageTicket"
                />
              </TableCell>
            </template>
          </TableRow>
        </template>
      </TableBody>
    </Table>
  </div>
</template>

<script>
import {
  RenderMoneyColumnValue,
  RenderPercentageColumnValue,
} from '../../../ui/render';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../ui/table';
import { setPanoramaInvoiceStatusColor } from '../utils';
import RenderPanoramaSummaryInvoiceLine from './render-panorama-summary-invoice-line-value.vue';

/**
 * @typedef {Object} InvoiceData
 * @property {number} boletoVeins
 * @property {string} status
 */

/**
 * Objeto que representa as Faturas Atrasadas em modelo para a construção da tabela de Resumo
 * @typedef {Object} PanoramaInvoiceSummary
 * @property {string} name Nome do status judicial.
 * @property {number} total Valor total dos boletos vencidos.
 * @property {number} subtotal Subtotal dos boletos vencidos.
 * @property {number} qtyInvoiceInStatus Quantidade de faturas naquele status.
 * @property {InvoiceData[] | null} january Lista de faturas vencidas em janeiro.
 * @property {InvoiceData[] | null} february Lista de faturas vencidas em fevereiro.
 * @property {InvoiceData[] | null} march Lista de faturas vencidas em março.
 * @property {InvoiceData[] | null} april Lista de faturas vencidas em abril.
 * @property {InvoiceData[] | null} may Lista de faturas vencidas em maio.
 * @property {InvoiceData[] | null} june Lista de faturas vencidas em junho.
 * @property {InvoiceData[] | null} july Lista de faturas vencidas em julho.
 * @property {InvoiceData[] | null} august Lista de faturas vencidas em agosto.
 * @property {InvoiceData[] | null} september Lista de faturas vencidas em setembro.
 * @property {InvoiceData[] | null} october Lista de faturas vencidas em outubro.
 * @property {InvoiceData[] | null} november Lista de faturas vencidas em novembro.
 * @property {InvoiceData[] | null} december Lista de faturas vencidas em dezembro.
 */

export default {
  components: {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    TableHeader,
    RenderMoneyColumnValue,
    RenderPercentageColumnValue,
    RenderPanoramaSummaryInvoiceLine,
  },
  props: {
    /**
     * Lista de Faturas por status
     * @default []
     * @type {PanoramaInvoiceSummary[]}
     */
    panoramaStatusSummaryList: {
      type: Array,
      default: [],
    },
    panoramaMonthsColumns: {
      type: Array,
      default: [],
    },
    selectedFields: {
      type: Object,
      default: () => ({
        invoiceValue: true,
        qtyInvoices: true,
        overallPercentage: true,
        subTotalPercentage: true,
        averageTicket: true,
      }),
    },
  },
  data() {
    return {
      initialPanoramaSummaryColumns: [
        {
          key: 'invoice',
          label: 'Status Fatura',
          colspan: 3,
          style:
            'width: 300px; display:flex; justify-content: space-between; align-items: center;',
          class: 'pinned lv0 divider',
        },
        {
          key: 'total',
          label: 'Total',
          class: 'pinned lv3 divider',
        },
      ],
      toggleGroups: [],
      toggleSubgroups: [],
    };
  },

  computed: {
    /**
     * Colunas da tabela de resumo
     * @type {Object[]}
     */
    panoramaSummaryColumns() {
      const panoramaColumns = [].concat(this.initialPanoramaSummaryColumns);
      const panoramaMonthsColumns = this.panoramaMonthsColumns.map(
        panoramaMonthsCol => {
          return {
            label: this.convertShortMonthToFull(panoramaMonthsCol.name),
            key: panoramaMonthsCol.key,
            class: 'divider',
          };
        },
      );

      return panoramaColumns.concat(panoramaMonthsColumns);
    },
  },

  methods: {
    /**
     * Retorna o total dos valores de Boleto Veins dado uma lista de Faturas atrasadas
     *
     * @param {PanoramaInvoiceSummary[]} panoramaList
     * @returns {function(): number}
     */
    getSumBoletoVeinsByPanoramaList(panoramaList) {
      return panoramaList.total;
    },
    /**
     * Retorna o total de porcentagem dado uma lista de Faturas atrasadas
     *
     * @param {PanoramaInvoiceSummary[]} panoramaList
     * @returns {function(): number}
     */
    getSumPercentageByPanoramaList(panoramaList) {
      return panoramaList.percentageOfTotalOverall;
    },
    /**
     * Calcula o valor total dos boletos vencidos para um determinado prefixo de status judicial.
     *
     * @param {string} statusPrefix - Prefixo do status judicial para filtrar (primeira letra do status).
     * @param {PanoramaInvoiceSummary[]} panoramaInvoiceSummaryList - Lista de resumos de faturas vencidas, agrupadas por status e mês.
     *
     * @returns {number} O valor total dos boletos vencidos para o prefixo de status especificado.
     *
     * @example
     * const total = getTotalAmountByStatusPrefix('L', panoramaInvoiceSummaryList);
     * console.log(total); // Output: valor total dos boletos vencidos para status que começam com 'L'
     */
    getTotalAmountByStatusPrefix(statusPrefix, panoramaInvoiceSummaryList) {
      let total = 0;
      panoramaInvoiceSummaryList.forEach(panoramaInvoice => {
        if (panoramaInvoice.name.substring(1, 2) === statusPrefix) {
          total = total + panoramaInvoice.subtotal;
        }
      });
      return total;
    },
    /**
     * Retorna o estilo CSS associado a um status de resumo de fatura específico.
     *
     * @param {string} name - O nome do status de resumo da fatura.
     * @returns {string} O estilo CSS associado ao status de resumo da fatura.
     */
    setInvoiceSummaryStatusColor(name) {
      return setPanoramaInvoiceStatusColor(name);
    },
    translatePanoramaSummaryStatusName(name) {
      return name;
    },
    toggleGroup(index) {
      if (this.toggleGroups.includes(index)) {
        this.toggleGroups = this.toggleGroups.filter(item => item !== index);
      } else {
        this.toggleGroups.push(index);
      }
    },
    toggleSubgroup(index) {
      if (this.toggleSubgroups.includes(index)) {
        this.toggleSubgroups = this.toggleSubgroups.filter(
          item => item !== index,
        );
      } else {
        this.toggleSubgroups.push(index);
      }
    },

    toggleAllGroupsAndSubgroups() {
      for (let i = 0; i < this.panoramaStatusSummaryList.length; i++) {
        const panoramaStatus = this.panoramaStatusSummaryList[i];
        console.log(panoramaStatus.invoicesData);
      }

      if (this.toggleGroups.length === 0) {
        this.toggleGroups = this.panoramaStatusSummaryList.map(
          panoramaStatus => panoramaStatus.name,
        );
        this.toggleSubgroups = this.panoramaStatusSummaryList
          .map(panoramaStatus => panoramaStatus.subGroups)
          .flat()
          .map(panoramaSubGroup => panoramaSubGroup.name);
      } else {
        this.toggleGroups = [];
        this.toggleSubgroups = [];
      }
    },

    convertShortMonthToFull(label) {
      const [year, shortMonth] = label.split(',').map(s => s.trim());
      const monthMap = {
        JAN: 'JANEIRO',
        FEV: 'FEVEREIRO',
        MAR: 'MARÇO',
        ABR: 'ABRIL',
        MAI: 'MAIO',
        JUN: 'JUNHO',
        JUL: 'JULHO',
        AGO: 'AGOSTO',
        SET: 'SETEMBRO',
        OUT: 'OUTUBRO',
        NOV: 'NOVEMBRO',
        DEZ: 'DEZEMBRO',
      };
      const fullMonth = monthMap[shortMonth] || shortMonth;
      return `${year}, ${fullMonth}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.panorama-summary-table {
  display: block;

  .pinned {
    position: sticky;
    background-color: #e7e7e7;
  }

  .lv0 {
    left: 1px;
  }

  .lv1 {
    left: 22px;
  }

  .lv2 {
    left: 44px;
  }

  .lv3 {
    left: 317px;
  }

  .lv0 .status {
    width: 300px;
  }

  .lv1 .status {
    width: 278px;
  }

  .lv2 .status {
    width: 256px;
  }

  .empty-cell {
    width: 5px;
  }

  .divider {
    border-right: 2px solid gray;
  }

  tr:nth-child(odd) td:nth-child(-n + 4).pinned {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td:nth-child(-n + 4).pinned {
    background-color: #f2f2f2;
  }
}
.panorama-summary-table-cell {
  height: 20px !important;
}
</style>
